import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AvatarUrlFields } from '~/avatar/types'

import { RootState } from '../store'

interface AvatarState {
  avatarFields: AvatarUrlFields
  avatarError: boolean
  downloadUrl: string
  avatarPng: string
}

const initialState: AvatarState = {
  avatarFields: { avatarUrl: '', avatarPng: '', childAvatar: false },
  avatarError: false,
  downloadUrl: '',
  avatarPng: '',
}

const slice = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    setAvatarFields: (state, action: PayloadAction<AvatarUrlFields>) => ({
      ...state,
      avatarFields: action.payload,
    }),
    setAvatarError: (state, action: PayloadAction<boolean>) => ({
      ...state,
      avatarError: action.payload,
    }),
    setDownloadUrl: (state, action: PayloadAction<string>) => ({
      ...state,
      downloadUrl: action.payload,
    }),
    setAvatarPng: (state, action: PayloadAction<string>) => ({
      ...state,
      avatarPng: action.payload,
    }),
    resetAvatarState: (state) => ({
      ...state,
      ...initialState,
    }),
  },
})

export const selectAvatarFields = (state: RootState): AvatarUrlFields => {
  return state.avatar.avatarFields
}
export const selectAvatarError = (state: RootState): boolean => {
  return state.avatar.avatarError
}
export const selectDownloadUrl = (state: RootState): string => {
  return state.avatar.downloadUrl
}
export const selectAvatarPng = (state: RootState): string => {
  return state.avatar.avatarPng
}

export const { setAvatarFields, setAvatarError, setDownloadUrl, setAvatarPng, resetAvatarState } = slice.actions

export default slice.reducer
